var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0017 5.71373C12.7088 5.71373 15.1231 7.23516 16.3017 9.6423C15.1231 12.0494 12.7088 13.5709 10.0017 13.5709C7.29453 13.5709 4.88025 12.0494 3.70167 9.6423C4.88025 7.23516 7.29453 5.71373 10.0017 5.71373ZM10.0017 4.28516C6.43024 4.28516 3.38025 6.50658 2.14453 9.6423C3.38025 12.778 6.43024 14.9994 10.0017 14.9994C13.5731 14.9994 16.6231 12.778 17.8588 9.6423C16.6231 6.50658 13.5731 4.28516 10.0017 4.28516ZM10.0017 7.85658C10.9874 7.85658 11.7874 8.65658 11.7874 9.6423C11.7874 10.628 10.9874 11.428 10.0017 11.428C9.01596 11.428 8.21596 10.628 8.21596 9.6423C8.21596 8.65658 9.01596 7.85658 10.0017 7.85658ZM10.0017 6.42801C8.23024 6.42801 6.78739 7.87087 6.78739 9.6423C6.78739 11.4137 8.23024 12.8566 10.0017 12.8566C11.7731 12.8566 13.216 11.4137 13.216 9.6423C13.216 7.87087 11.7731 6.42801 10.0017 6.42801Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.fd2f00d01689dbfb25d821dbbed14999.svg";
export { ForwardRef as ReactComponent };